import { consentChanged, getConsentForGV } from "@otto-ec/eprivacy-cmp";
import { sendLog } from "@otto-ec/global-resources/debug";
import { isPrivacyPage } from "@otto-ec/global-resources/misc";
import { get } from "@otto-ec/global-resources/toggle";

export const BLOCKLIST = [
  /^\/order(?!\/(?:confirmation|checkout)(?:\/|$))(?:\/|$)/,
  /^\/payment-selection(?:\/|$)/,
  /^\/payment-mandates(?:\/|$)/,
  /^\/dad-date(?:\/|$)/,
  /^\/dad-view(?:\/|$)/,
  /^\/customer-registration(?:\/|$)/,
];

export const isPathBlocklisted = (pathname: string): boolean => {
  return BLOCKLIST.some((regex) => regex.test(pathname));
};

const init = async (): Promise<void> => {
  /*                  */
  const { unifiedSDK: initCheck } = window;

  if (initCheck) {
    return;
  }

  const currentPathname = window.location.pathname;

  /*                                             */
  if (!import.meta.env.DEV) {
    if (
      !get("verint_enable_xmsdk", true) ||
      isPrivacyPage() ||
      !(await getConsentForGV("POLMG")) ||
      isPathBlocklisted(currentPathname)
    ) {
      return;
    }
  }

  const containerCookie = document.cookie
    .split("; ")
    .find((row) => row.startsWith("uws_container_override="));
  const containerValue =
    containerCookie && JSON.parse(decodeURIComponent(containerCookie.split("=")[1]));
  const config = {
    moduleHost: import.meta.env.VITE_VERINT_MODULE_HOST,
    configHost: import.meta.env.VITE_VERINT_CONFIG_HOST,
    modulePath: `${import.meta.env.BASE_URL}/${import.meta.env.VITE_VERINT_SOURCE_HASH}/modules/{file}`,
    customAssetPath: `${import.meta.env.BASE_URL}/${import.meta.env.VITE_VERINT_SOURCE_HASH}/custom/{file}`,
    siteKey: import.meta.env.VITE_VERINT_SITE_KEY,
    container: import.meta.env.VITE_VERINT_CONTAINER,
    loadTime: Date.now(),
  };
  config.container = containerValue || config.container;
  config.loadTime = Date.now();
  try {
    await import(
      `${import.meta.env.BASE_URL}/${import.meta.env.VITE_VERINT_SOURCE_HASH}/modules/sdk.js`
    );

    const readyCallbacks: never[] = [];
    window.uwsReady = (callback) => readyCallbacks.push(callback);

    window.unifiedSDK.start(config, readyCallbacks);
  } catch (e) {
    sendLog("verintRuntimeError", {
      error: e.toString(),
      stack: e.stack,
    });
  }
};

consentChanged.on(init);
export default init();
